<div class="db-one-month-free-payment-steps-wrap">
  <div class="db-one-month-free-payment-steps">
    <div class="db-one-month-free-payment-steps-icons">
      <div class="db-one-month-free-payment-steps__step active">
        <span><i class="db-icon db-icon-ds-unlocked"></i></span>
      </div>
      <span class="db-one-month-free-payment-steps__separator active"></span>
      <div class="db-one-month-free-payment-steps__step">
        <span><i class="db-icon db-icon-ds-checkmark"></i></span>
      </div>
      <span class="db-one-month-free-payment-steps__separator dashed"></span>
    </div>
    <div class="db-one-month-free-payment-steps-desc">
      <div>
        <p><b>Today</b></p>
        <p>{{userSubscription?.type === userSubscriptionTypes.FREE ? 'Unlock 10Web Pro plans.' : 'Pay'+ ' $' + (userSubscription?.plan?.price + (userSubscription?.plan?.additionalCDNPrice ? userSubscription?.plan?.additionalCDNPrice : 0) +
                userSubscription?.plan?.additionalDomainPrice)  + ', unlock 10Web Pro.'}}</p>
      </div>
      <div>
        <p><b>{{expirationDate | date: 'MMMM d, y'}}</b></p>
        <p>Your next payment date.</p>
      </div>
    </div>
  </div>
</div>

<db-carousel [template]="reviewCarouselRef" [items]="reviewers" [height]="132"></db-carousel>

<div class="db-one-month-free-checkout-info__trust-pilot mt35">
  <div class="g2">
    <img src="assets/images/logos/services/g2_FI_2020.svg" alt="">
    <img src="assets/images/logos/services/g2_HP_2021.svg" alt="">
  </div>
  <db-trustpilot></db-trustpilot>
</div>

<ng-template #reviewCarouselRef let-item='item'>
  <div class="db-one-month-free-checkout-info__carousel">
    <div class="mb8">
      <img src="{{item.img}}" alt="">
      <i [innerHTML]="'- ' + item.title"></i>
    </div>
    <p><i [innerHTML]="item.desc"></i></p>
  </div>
</ng-template>
